import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss']
})
export class DeletePopupComponent implements OnInit {
    isActiveStatus = false;
  constructor(
    public dialogRef: MatDialogRef<DeletePopupComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.statusNameType === 'active'){
        this.isActiveStatus = true;
      }
   }

  onNoClick(com: any): void {
    this.dialogRef.close(com);
  }

  ngOnInit(): void {
  }
  

}
 